import React, {useEffect, useState} from 'react';
import {Dialog, DialogContent, Button, Typography, Stack, IconButton} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import axios from 'axios';
import caseFileDeclined from "../../enums/CaseFileDeclined";
import CaseFileDeclined from "../../enums/CaseFileDeclined";
import CaseStatus from "../../enums/CaseStatus";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import TextField from "@mui/material/TextField";
import NomenclatureEnum from "../../enums/nomenclatureEnum";

const DeclineDaysExtension = ({onFileAdded, onCaseStatusChange, files, prolongationDaysForInput, nomenclautureId}) => {
    const [open, setOpen] = useState(false);
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const filesToUpdate = files.filter(file => file.decline === CaseFileDeclined.DeclinationDocument)
    const [prolongationDays, setProlongationDays] = useState(null);
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    const [prolongationDaysError, setProlongationDaysError] = useState('');
    const [fileSizeError, setFileSizeError] = useState('');


    const handleOpenConfirmationModal = () => {
        setIsConfirmationModalOpen(true);
    };

    const handleCloseConfirmationModal = () => {
        setIsConfirmationModalOpen(false);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        resetFile();
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            if (selectedFile.size > 10 * 1024 * 1024) {
                setFileSizeError('ფაილი აღემატება 10 მბ-ს');
                return;
            } else {
                setFileSizeError('');
            }
            setFileName(selectedFile.name);
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                setFile(reader.result.replace(/^data:.+;base64,/, ''));
            };
        }
    };

    const handleProlongationDaysChange = (event) => {
        const value = event.target.value;



        if (value > 15) {
            setProlongationDaysError(`დღეების მაქსიმალური რაოდენობა: 15`)
        }
        else {
            setProlongationDaysError('');
        }
        setProlongationDays(value);
    };



    const sendNotification = async (caseType, fileId) => {
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddCaseNotificationRangeByCaseId`, {
                caseId: caseType,
                caseStatus: CaseStatus.Sent.id,
                action: 27,
                caseFileIds: [fileId],
                declinationDays: parseInt(prolongationDays, 10) + parseInt(prolongationDaysForInput, 10)
            });

        } catch (error) {
        }
    };

    const handleSubmit = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const caseID = urlParams.get('id');
        const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`;
        const data = {
            caseID: parseInt(caseID),
            name: "დახარვეზების დღეების გახანრძლივება",
            ext: "pdf",
            mainInfo: "",
            additionalInfo: "",
            file: file,
            shared: true,
            blank: false,
            documentType: 0,
            internal: false,
            status: 3,
            decline: CaseFileDeclined.ExtendDaysDocumentActive,
            fileTypeId: 23,
            tempProlongationDays: parseInt(prolongationDays, 10) + parseInt(prolongationDaysForInput, 10),
            declinedInternalStatus: 0,
            casefileNumber: "/2"

        };

        try {
            const response = await axios.post(apiUrl, data);
            resetFile();
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseStatusByUser`, {
                caseId: parseInt(caseID),
                caseStatus: CaseStatus.CaseCreatedWithFiles.id,
                finished: false
            });
            if (filesToUpdate.length > 0) {
                await updateFileStatus(filesToUpdate);
            }
            await sendNotification(caseID, response.data.resultId)
            handleClose();
            onCaseStatusChange();
            onFileAdded();
        } catch (error) {
        }
    };


    const updateFileStatus = async (files) => {
        try {
            await Promise.all(files.map(async (file) => {
                const updatedFile = {
                    ...file,
                    decline: caseFileDeclined.CaseFileIsPending
                };

                await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditCaseFile`, updatedFile);
            }));

        } catch (error) {
        }
    };

    const handlePreview = () => {
        if (!file) return;
        const byteCharacters = atob(file);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const fileBlob = new Blob([byteArray], {type: 'application/pdf'});
        const fileURL = URL.createObjectURL(fileBlob);
        window.open(fileURL, '_blank');
    };

    const resetFile = () => {
        setFile(null);
        setFileName('');
        document.getElementById('contained-button-file').value = '';
    };
    return (
        <div>
            <button className={"document-buttonn"} onClick={handleClickOpen}>
                დახარვეზების დღეების გახანრძლივება
            </button>
            <Dialog style={{zIndex: 34}} fullWidth maxWidth="sm" open={open} onClose={handleClose}>
                <DialogContent>
                    <Typography> დღეების რაოდენობა: {prolongationDaysForInput}</Typography>
                    <Stack direction="column" spacing={2}>
                        <input
                            accept="application/pdf"
                            style={{display: 'none'}}
                            id="contained-button-file"
                            type="file"
                            onChange={handleFileChange}
                        />
                        <TextField
                            label="დღეების რაოდენობა"
                            type="number"
                            value={prolongationDays}
                            onChange={handleProlongationDaysChange}
                            error={prolongationDaysError !== ''}
                            helperText={prolongationDaysError}
                            inputProps={{
                                min: 0,
                                max: 15,
                                'aria-label': 'Prolongation Days'
                            }}
                            variant="outlined"
                            fullWidth
                        />

                        <label htmlFor="contained-button-file">
                            <Button fullWidth variant="contained" component="span">
                                ფაილის ატვირთვა (მაქს. 10mb.)
                            </Button>
                        </label>
                        {fileSizeError && (
                            <div>
                                <Typography variant="body1" color="error">
                                    {fileSizeError}!
                                </Typography>
                            </div>
                        )}
                        {fileName && (
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Typography variant="body1">{fileName}</Typography>
                                <IconButton aria-label="preview" onClick={handlePreview}>
                                    <VisibilityIcon/>
                                </IconButton>
                                <IconButton aria-label="delete" onClick={resetFile}>
                                    <DeleteIcon/>
                                </IconButton>
                            </Stack>
                        )}
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleOpenConfirmationModal}
                            disabled={!file || prolongationDays < 1 || prolongationDaysError !== ''}
                        >
                            გაგზავნა
                        </Button>
                    </Stack>
                </DialogContent>
            </Dialog>
            <ConfirmationModal
                isOpen={isConfirmationModalOpen}
                onRequestClose={handleCloseConfirmationModal}
                onConfirm={handleSubmit}
            />
        </div>
    );
};

export default DeclineDaysExtension;
